export default __webpack_public_path__ + "static/media/logo.967a1b71.png";